<fidelity-overlay-page-wrapper
    *transloco="let t; prefix 'fidelity-app.register'"
    [headerCaption]="t('heading')"
    [errorComponent]="errorComponent()"
>
    <div pageContent class="flex flex-col items-center flex-grow h-full" [class.overflow-hidden]="!registrationModeChosen()" *transloco="let gt">
        @if (brandsService.logoUrl) {
            <img
                #brandLogo
                class="mb-2 mx-auto w-full object-contain"
                [ngClass]="{'min-h-0 flex-shrink': !registrationModeChosen()}"
                [src]="brandsService.logoUrl"
                alt="Logo image"
            />
        }

        @if (!registrationModeChosen()) {
            <div class="w-full flex flex-col gap-y-4 items-center text-center" @fadeIn @fadeOut>
                <div>
                    <h3 class="text-tb-primary">{{ t('use-card-for-registration-caption') }}</h3>
                    <p>{{ t('use-card-for-registration-caption-descriptive') }}</p>
                </div>
                <button
                    class="fuse-mat-button-large w-full enabled:bg-tb-primary enabled:text-tb-primary-contrast"
                    mat-flat-button
                    (click)="setCardRegistrationMode()"
                >
                <span>
                    {{ t('use-card-for-registration') }}
                </span>
                </button>
                <div class="flex flex-row items-center w-full">
                    <span class="border-t flex-grow"></span>
                    <span class="text-secondary mx-4">{{ gt('generic.or') }}</span>
                    <span class="border-t flex-grow"></span></div>
                <p>{{ t('new-registration-caption') }}</p>
                <button
                    class="fuse-mat-button-large w-full enabled:bg-tb-primary enabled:text-tb-primary-contrast"
                    mat-flat-button
                    (click)="setNewRegistrationMode()"
                >
                <span>
                    {{ t('new-registration') }}
                </span>
                </button>
            </div>
        } @else {
            <app-registration-form
                @fadeIn @fadeOut
                class="pb-4"
                [fullErrorMessage]="fullErrorMessage()"
                [hideCardInput]="hideCardInput()"
                (onDismiss)="dismissError()"
                (onRegister)="onRegister($event)"></app-registration-form>
        }
    </div>
</fidelity-overlay-page-wrapper>
